import {
  GET_INSPECTION_REPORT,
  GET_INSPECTION_REPORT_SUCCESS,
  GET_INSPECTION_REPORT_FAIL,
} from '../constants/types';

const initState = {
  loading: false,
  data: '',
  error: '',
};

const provenance = (state = initState, action) => {
  switch (action.type) {
    case GET_INSPECTION_REPORT:
      return {
        ...state,
        loading: true,
      };
    case GET_INSPECTION_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data,
        error: '',
      };
    case GET_INSPECTION_REPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        data: '',
      };
    default:
      return state;
  }
};

export default provenance;
